import React,{useState, useEffect} from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./FrameworksTabs.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { color } from "framer-motion";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
 
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({imagesObj}) {
  const [value, setValue] = React.useState(0);
  const [val, setVal] = React.useState("frame");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const setValImg = (name, vals) => {
    setVal(name);
    setValue(vals);
  };
  return (
    <>
      <div className="framework-tabs-holo">
        <div className="framework-tabs-wrap-holo">
          <div className="zeal" onClick={() => setValImg("frame", 0)}>
            <img
              style={{ width: "90%", cursor: "pointer" }}
              src={
                val == "frame"
                  ? process.env.PUBLIC_URL +
                    "/images/Home/Active-tab-new-old.png"
                  : process.env.PUBLIC_URL + "/images/Home/Disabled-tab-new.png"
              }
            />
            <span
              style={{
                color: val == "frame" ? "#fff" : "#7E7E7E",
                cursor: "pointer",
                left: "30%",
                // top: val === "frame" ? "10px" : "0px",
              }}
            >
              Framework
            </span>
          </div>
          <div className="zeal" onClick={() => setValImg("approach", 1)}>
            <img
              style={{ width: "90%", cursor: "pointer" }}
              // src={process.env.PUBLIC_URL + "/images/Home/Active-tab-new.png"}
              src={
                val == "approach"
                  ? process.env.PUBLIC_URL +
                    "/images/Home/Active-tab-new-old.png"
                  : process.env.PUBLIC_URL + "/images/Home/Disabled-tab-new.png"
              }
            />
            <span
              style={{
                color: val == "approach" ? "#fff" : "#7E7E7E",
                cursor: "pointer",
                left: "30%",
                // top: val === "approach" ? "10px" : "0px",
              }}
            >
              Approach
            </span>
          </div>
          <div className="zeal" onClick={() => setValImg("learning", 2)}>
            <img
              style={{ width: "90%", cursor: "pointer" }}
              // onClick={() => setValImg("learning", 2)}
              // src={process.env.PUBLIC_URL + "/images/Home/Active-tab-new.png"}
              src={
                val == "learning"
                  ? process.env.PUBLIC_URL +
                    "/images/Home/Active-tab-new-old.png"
                  : process.env.PUBLIC_URL + "/images/Home/Disabled-tab-new.png"
              }
            />
            <span
              style={{
                color: val == "learning" ? "#fff" : "#7E7E7E",
                cursor: "pointer",
                left: "25%",
                // top: val === "learning" ? "10px" : "0px",
              }}
            >
              Learning Journey
            </span>
          </div>
        </div>
      </div>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            {/* <Tab label="Framework" {...a11yProps(0)} />
            <Tab label="Approach" {...a11yProps(1)} />
            <Tab label="Learning Journey" {...a11yProps(2)} /> */}
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <div className="framework-tabs-row" data-aos="zoom-in-up">
            <h3 className="readi-framework-head">
            VodafoneThree Talent Academy Framework
            </h3>
            <img
              src={imagesObj?.img12}
              alt="infographics"
              className="Framework-infographics"
            />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <div className="framework-tabs-row" data-aos="zoom-in-up">
            <h3>VodafoneThree Talent Academy Approach</h3>
            <img
              src={imagesObj?.img4}
              alt="infographics"
              className="Approach-infographics"
            />
            <h3>Proficiency Levels</h3>
            <img
              src={imagesObj?.img22}
              alt="infographics"
              className="Profeciency-infographics"
            />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <div className="framework-tabs-row" data-aos="zoom-in-up">
            <h3>Learning Journey</h3>
            <img
              src={imagesObj?.img23}
              alt="elevate"
              className="elevate-info"
            />
          </div>
        </CustomTabPanel>
      </Box>
    </>
  );
}
